
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referandearn",
      function () {
        return require("private-next-pages/referandearn.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referandearn"])
      });
    }
  